export type Locale = 'de-DE' | 'en-GB' | 'es-ES' | 'fr-FR' | 'it-IT' | 'nl-BE';

export interface LocaleInfo {
  icon: string;
  name: string; // localized name of locale (should not be translated)
}

export const LOCALES_INFO_MAP: Record<Locale, LocaleInfo> = {
  'de-DE': { icon: 'flag-de-de', name: 'Deutsch' },
  'en-GB': { icon: 'flag-en-gb', name: 'English' },
  'es-ES': { icon: 'flag-es-es', name: 'Español' },
  'fr-FR': { icon: 'flag-fr-fr', name: 'Français' },
  'it-IT': { icon: 'flag-it-it', name: 'Italiano' },
  'nl-BE': { icon: 'flag-nl-be', name: 'Vlaams' },
};

export const AVAILABLE_LOCALES: Locale[] = Object.keys(LOCALES_INFO_MAP) as Locale[];

export const FALLBACK_LANG: Locale = 'en-GB';

export const FORM_DEFAULT_LANG: Locale = 'fr-FR';

export const scopeLoader = (importer: (lang: Locale, root: string) => void) => {
  return AVAILABLE_LOCALES.reduce((acc: any, lang: Locale) => {
    acc[lang] = () => importer(lang, 'i18n');
    return acc;
  }, {});
};
